angular.module('storefrontApp')
    .controller('addressMatchesDialogController', [
        '$scope',
        '$uibModalInstance',
        'dialogData',
        function (
            $scope,
            $uibModalInstance,
            dialogData,
        ) {
            $scope.model = {};
            $scope.model.selectedAddress = null;
            $scope.addresses = _.each(dialogData.matches, populateRegionalDataForAddressMatches);

            $scope.select = function () {
                $uibModalInstance.close($scope.model.selectedAddress);
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            $scope.stringifyAddress = function (address) {
                return address.line1 + ', '
                    + address.city + ', '
                    + (address.regionName ? address.regionName + ', ' : '')
                    + address.postalCode + ' '
                    + address.countryName;
            };

            function setAddressRegion(address, regions) {
                address.region = _.findWhere(regions, {
                    code: address.regionId,
                });

                if (address.region) {
                    address.regionId = address.region.code;
                    address.regionName = address.region.name;
                } else {
                    address.regionId = undefined;
                    address.regionName = undefined;
                }
            }

            function populateRegionalDataForAddressMatches(address) {
                if (address) {
                    address.postalCode = address.zip;

                    delete address.zip;
                    delete address.type;

                    // Set country object for address
                    address.country = _.findWhere(dialogData.countries, { code2: address.countryName });

                    if (address.country != null) {
                        address.countryName = address.country.name;
                        address.countryCode = address.country.code3;
                    }

                    if (address.country && address.country.regions) {
                        setAddressRegion(address, address.country.regions);
                    }
                }
            }
        }]);
